"use client";

import { useEffect, useState, useRef } from "react";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import dynamic from "next/dynamic";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { getUserInfo } from "../../../utilities/userInfo";
import FilterBar from "@/app/cin_booking_engine/Filterbar";
import { BookingEngineProvider } from "@/app/cin_context/BookingEngineContext";
import HeaderInner from "@/components/HeaderInner";
import PropertyBackgroundImage from "@/components/PropertyBackgroundImage";
import TigerLoader from "@/components/TigerLoader";
// import MaintainancePopup from "@/components/MaintainancePopup";

const OverExp = dynamic(() => import("@/sliders/OverExp"), {
  ssr: false,
  loading: () => null,
});
const DiningSlider = dynamic(() => import("@/sliders/DiningSlider"), {
  ssr: false,
  loading: () => null,
});
const HotelOffers = dynamic(() => import("@/sliders/HotelOffers"), {
  ssr: false,
  loading: () => null,
});
const EventSlider = dynamic(() => import("@/sliders/EventSlider"), {
  ssr: false,
  loading: () => null,
});
const GalleryPage = dynamic(() => import("@/components/HomeGallery"), {
  ssr: false,
  loading: () => null,
});

export default function CityOverviewPage() {
  const searchParams = useSearchParams();
  const { propertySlug } = useParams();
  const [propertyId, setPropertyId] = useState(null);
  const [propertyData, setPropertyData] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLuxuryExpanded, setIsLuxuryExpanded] = useState(false);
  const [brandId, setBrandId] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [isHandleSearchProp, setHandleSearchProp] = useState(false);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const filterBarRef = useRef(null);
  const [staahPropertyId, setStaahPropertyId] = useState(null);
  const [cityDetails, setCityDetails] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [brandData, setBrandData] = useState([]);
  const [isSearchClick, setIsSearchClick] = useState(false);
  const [roomsBannerData, setRoomsBannerData] = useState();
  // const [callBookNow, setCallBookNow] = useState(false);
  const [staahOfferId, setStaahOfferId] = useState(0);
  const [queryParam, setQueryParam] = useState(null);

  const brandColors = {
    1: "#bf1e2d",
    4: "#bf1e2d",
    2: "#263997",
    3: "#f04e02",
    5: "#febb19",
    6: "#f9e12e",
  };

  const backgroundColor = brandColors[brandId] || "black";

  const handlePropertyBookNow = async (rooms) => {
    
    if(Number(rooms?.propertyOfferId || "0") > 0 ){

    setStaahOfferId(rooms?.propertyOfferId);
    }
    else{
      
    setStaahOfferId(0);
    }
    setIsSearchClick(true);
    // setCityDetails(rooms);
    if (window.innerWidth < 768) {
      setOpen(!isOpen);
      setShowFilterBar(!showFilterBar);
    }
    setHandleSearchProp(true);
    if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      const firstInput = filterBarRef.current.querySelector(
        "input, select, button",
      );
      if (firstInput) firstInput.focus();
    }
  };

  const renderHTML = (html) => ({
    __html: html,
  });

  async function postBookingWidged(
    rooms,
    mapping,
    isClose,
    ctaName,
    selectedPropertyId,
  ) {
    const resp = await getUserInfo();
    const sessionId = sessionStorage?.getItem("sessionId");
    const payload = {
      ctaName: ctaName,
      urls: window.location.href,
      cityId: "0",
      propertyId: selectedPropertyId?.toString() || "0",
      checkIn: "",
      checkOut: "",
      adults: "0",
      children: "0",
      rooms: "0",
      promoCode: "",
      ip: resp?.ip,
      sessionId: sessionId,
      deviceName: resp?.deviceInfo?.deviceName,
      deviceType:
        resp?.deviceInfo?.deviceOS == "Unknown"
          ? resp?.deviceInfo?.platform
          : resp?.deviceInfo?.deviceOS,
      roomsName: rooms?.RoomName,
      packageName: mapping?.MappingName,
      isCartOpen: mapping?.MappingName ? "Y" : "N",
      isCartEdit: "N",
      isCartClick: "N",
      isClose: isClose ? "Y" : "N",
    };
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/Api/tracker/BookingWidged`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );
    const res = await response?.json();
  }
  useEffect(() => {
    if (typeof window !== "undefined") {
      setShowFilterBar(window.innerWidth >= 768);
      setIsMobile(window.innerWidth < 768);
    }
    const storedBrandId = localStorage.getItem("brandId");
    setBrandId(storedBrandId);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!propertyId) return;
    let cancelled = false;
    const fetchRoomsDetails = async () => {
      if (!propertyId) return;
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/Property/GetPropertyRoomBanner?PropertyId=${propertyId}`,
        );
        const json = await res.json();
        if (!cancelled) setRoomsBannerData(json.data?.[0]);

        if (json.errorMessage !== "success") {
          console.error("Property details fetch error:", json);
          return;
        }
      } catch (error) {
        console.error("Error fetching property details:", error);
      }
    };

    fetchRoomsDetails();
    return () => {
      cancelled = true;
    };
  }, [propertyId]);

  // Fetch brand data
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const cached =
          typeof window !== "undefined"
            ? sessionStorage.getItem("brandList")
            : null;
        if (cached) {
          const parsed = JSON.parse(cached);
          if (!cancelled) setBrandData(parsed || []);
          return;
        }
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetBrandList`,
        );
        const json = await res.json();
        if (!cancelled) setBrandData(json.data || []);
        try {
          sessionStorage.setItem("brandList", JSON.stringify(json.data || []));
        } catch {}
      } catch (e) {
        console.error("Error fetching brands:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!propertySlug) return;

    let cancelled = false;
    (async () => {
      try {
        const cacheKey = `propertyList`;
        const cached =
          typeof window !== "undefined"
            ? sessionStorage.getItem(cacheKey)
            : null;

        const json = cached
          ? { data: JSON.parse(cached) }
          : await (async () => {
              const res = await fetch(
                `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetPropertyList`,
              );
              const payload = await res.json();
              try {
                sessionStorage.setItem(
                  cacheKey,
                  JSON.stringify(payload?.data || []),
                );
              } catch {}
              return payload;
            })();

        const found = json?.data?.find((p) => p.propertySlug === propertySlug);
        if (found) {
          if (cancelled) return;
          setPropertyId(found?.propertyId);
          setCityDetails({
            label: found?.cityName,
            value: found?.cityId,
            property_Id: found?.staahPropertyId,
          });
          setStaahPropertyId(found?.staahPropertyId);
        }
      } catch (e) {
        console.error(e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [propertySlug]);

  useEffect(() => {
    if (!propertyId) return;

    let cancelled = false;
    (async () => {
      // setLoading(true);
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetPropertyByFilter?PropertyId=${propertyId}`,
        );
        const json = await res.json();
        if (!cancelled) setPropertyData(json?.data?.[0] ?? null);
      } catch (e) {
        console.error(e);
        if (!cancelled) setPropertyData(null);
      } finally {
        if (!cancelled) setIsPageLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [propertyId]);

  
  useEffect(() => {
    const queryParam = searchParams.get("book_now_popup");
    if(queryParam){
    setQueryParam(queryParam);
    }
  }, [searchParams]);

  
  useEffect(() => {
    if(queryParam){
       setTimeout(() => {
      handlePropertyBookNow();
  }, 500);
    }
  }, [queryParam]);

  // const handleBookNowfff = () => {
  //   setCallBookNow(true);
  // };

  if (isPageLoading) {
    return <TigerLoader />;
  }

  return (
    <>
    <main className="bg-white" style={{ overflowY: "auto" }}>
      <HeaderInner
        brandData={brandData}
        propertyData={propertyData}
        brandId={brandId}
        backgroundColor={backgroundColor}
        propertyId={propertyData?.propertyId}
        onClick={handlePropertyBookNow}
      />
      <section ref={filterBarRef} className="position-relative">
        <PropertyBackgroundImage propertyData={propertyData} />
        <section className="booking-form-section">
          {isMobile && (
            <div
              className={`booking-search-bar-btn-div home-page-class`}
              style={{ zIndex: 10 }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handlePropertyBookNow();
                }}
                className="booking-toggle-btn"
                style={{ background: backgroundColor }}
              >
                {isOpen ? <X size={18} color="black" /> : "Book Now"}
              </button>
            </div>
          )}

          {showFilterBar && typeof window !== "undefined" &&
            createPortal(
              <BookingEngineProvider>
                <FilterBar
                  selectedProperty={parseInt(cityDetails.property_Id)}
                  cityDetails={cityDetails}
                  openBookingBar={showFilterBar}
                  onClose={(isReload) => {
                    if (window.innerWidth < 768) {
                      setOpen(!isOpen);
                      setShowFilterBar(!showFilterBar);
                    }
                    if (isReload) {
                      window.location.reload();
                    }
                    setHandleSearchProp(false);
                  }}
                  backgroundColor={backgroundColor}
                  isSearchClick={backgroundColor}
                  isHandleSearchProp={isHandleSearchProp}
                    staahOfferId={parseInt(staahOfferId)}
                />
              </BookingEngineProvider>,
              document.body,
            )}
        </section>
      </section>
      {/* Top Banner */}
      <section
        className="bg-orange-600 text-white text-center py-12 px-4"
        style={{ background: backgroundColor }}
      >
        <h1 className="uppercase font-bold custom-hotel-header">
          {propertyData?.propertyName?.trim()}
        </h1>
        <div className="w-10 h-1 bg-white mx-auto mt-2 mb-4"></div>

        {/* Read More / Read Less Toggle */}
        {propertyData?.description && (
          <div className="max-w-4xl mx-auto custom-hotel-description">
            <div
              dangerouslySetInnerHTML={renderHTML(
                isMobile
                  ? isExpanded
                    ? propertyData.description
                    : propertyData.description.slice(0, 200) + "..."
                  : propertyData.description,
              )}
            />

            {/* Mobile Read More / Less */}
            {isMobile && (
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="text-white fw-semibold underline ms-2 mt-2 d-inline-block"
              >
                {isExpanded ? "Read Less" : "Read More"}
              </button>
            )}
          </div>
        )}
      </section>

      <section className="text-center py-12 px-4">
        <h2
          className="text-orange custom-hotel-header md:text-[23px] font-semibold mb-4"
          style={{ color: backgroundColor }}
        >
          {roomsBannerData?.roomBannerTitle}
        </h2>

        <div className="max-w-3xl custom-hotel-description mx-auto text-gray-600 pb-4">
          <div
            className="inline-desc"
            dangerouslySetInnerHTML={renderHTML(
              isLuxuryExpanded ||
                (roomsBannerData?.roomBannerDesc?.length || 0) <=
                  (isMobile ? 100 : 150)
                ? roomsBannerData?.roomBannerDesc
                : roomsBannerData?.roomBannerDesc?.slice(
                    0,
                    isMobile ? 100 : 150,
                  ) + "...",
            )}
          />

          {/* Read More / Read Less */}
          {roomsBannerData?.roomBannerDesc?.length >
            (isMobile ? 100 : 150) && (
            <button
              onClick={() => setIsLuxuryExpanded(!isLuxuryExpanded)}
              className="fw-semibold underline ms-2 d-inline-block"
              style={{ color: backgroundColor }}
            >
              {isLuxuryExpanded ? "Read Less" : "Read More"}
            </button>
          )}
        </div>

        <div className="container text-start">
          <OverExp
            backgroundColor={backgroundColor}
            propertyId={propertyData?.propertyId}
            propertyData={propertyData}
            onClick={handlePropertyBookNow}
          />
        </div>
      </section>

      {/* dining */}

      <DiningSlider
        brandData={brandData}
        backgroundColor={backgroundColor}
        propertyData={propertyData}
        propertyId={propertyData?.propertyId}
        onClick={handlePropertyBookNow}
      />

      <HotelOffers
        brandData={brandData}
        backgroundColor={backgroundColor}
        propertyData={propertyData}
        propertyId={propertyData?.propertyId}
        onClick={handlePropertyBookNow}
      />

      <EventSlider
        brandData={brandData}
        backgroundColor={backgroundColor}
        propertyData={propertyData}
        propertyId={propertyData?.propertyId}
        onClick={handlePropertyBookNow}
      />

      <GalleryPage
        backgroundColor={backgroundColor}
        propertyId={propertyData?.propertyId}
      />
    </main>
    </>
  );
}
